import React, { useState, useEffect, useRef } from 'react';
import { selectStyles } from '../../../../../assets/Styles/selectStyle';
import { getClients, getDistrict, getProjects, getStates } from '../../../../../services/monthlyAttendanceService';
import Select from 'react-select';
import 'react-datepicker/dist/react-datepicker.css';
// import './EmployeeEmailAndMobileNumberUpdate.css';
import './EmployeeEmailAndMobileNumberUpdate.css'
import { capitalizeFirstLetter, validateEmail } from '../../../../../utils/validations';
import { getEmployeeUpdationForEmailAndMobile, emailMobileUpdate } from '../../../../../services/salaryStructureService';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';

const EmployeeEmailAndMobileNumberUpdate = () => {
    const [state, setState] = useState(3);
    const [district, setDistrict] = useState(null);
    const [employees, setEmployees] = useState([]);
    const [employeeData, setEmployeeData] = useState([]);
    const [clientResponse, setClientResponse] = useState([]);
    const [projectResponse, setProjectResponse] = useState([]);
    const [clients, setClients] = useState(null);
    const [project, setProject] = useState(null);
    const [stateOptions, setStateOptions] = useState([]);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [formError, setFormError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false); // New state for submission
    const effectRan = useRef(false);
    const [isFocused, setIsFocused] = useState({
        state: false,
        district: false,
        clients: false,
        project: false,
    });
    const [errors, setErrors] = useState({});

    const navigate = useNavigate();

    // Fetch states
    useEffect(() => {
        const fetchStates = async () => {
            try {
                const data = await getStates();
                setStateOptions(
                    data.map(item => ({
                        value: item.id,
                        label: capitalizeFirstLetter(item.stateName),
                        name: capitalizeFirstLetter(item.stateName),
                    }))
                );
            } catch (error) {
                console.error('Error fetching states:', error);
                setErrors(prev => ({ ...prev, state: 'Failed to load states' }));
            }
        };
        if (!effectRan.current) {
            fetchStates();
        }
        return () => {
            effectRan.current = true;
        };
    }, []);

    // Fetch districts
    useEffect(() => {
        if (state) {
            const fetchDistricts = async () => {
                try {
                    const data = await getDistrict(state);
                    setDistrictOptions(
                        data.map(item => ({
                            value: item.districtId,
                            label: item.districtName,
                        }))
                    );
                } catch (error) {
                    console.error('Error fetching districts:', error);
                    setErrors(prev => ({ ...prev, district: 'Failed to load districts' }));
                }
            };
            fetchDistricts();
        } else {
            setDistrictOptions([]);
            setDistrict(null);
            setClients(null);
            setProject(null);
            setProjectResponse([]);
            setEmployees([]);
            setEmployeeData([]);
        }
    }, [state]);

    // Fetch clients
    useEffect(() => {
        if (state) {
            const fetchClients = async () => {
                try {
                    const data = await getClients(state);
                    setClientResponse(
                        data.map(client => ({
                            value: client.id,
                            label: client.clientName,
                        }))
                    );
                } catch (error) {
                    console.error('Error fetching clients:', error);
                    setErrors(prev => ({ ...prev, clients: 'Failed to load clients' }));
                }
            };
            fetchClients();
        } else {
            setClientResponse([]);
            setClients(null);
            setProject(null);
            setProjectResponse([]);
            setEmployees([]);
            setEmployeeData([]);
        }
    }, [state]);

    // Fetch projects
    useEffect(() => {
        if (clients) {
            const fetchProjects = async () => {
                try {
                    const data = await getProjects(clients);
                    setProjectResponse(
                        data.map(pro => ({
                            value: pro.id,
                            label: pro.projectCode,
                        }))
                    );
                    setProject(null);
                } catch (error) {
                    console.error('Error fetching projects:', error);
                    setErrors(prev => ({ ...prev, project: 'Failed to load projects' }));
                }
            };
            fetchProjects();
        } else {
            setProjectResponse([]);
            setProject(null);
            setEmployees([]);
            setEmployeeData([]);
        }
    }, [clients]);

    // Fetch employees based on project
    useEffect(() => {
        if (state) {
            const fetchEmployees = async () => {
                try {
                    const data = await getEmployeeUpdationForEmailAndMobile(state, clients, project, district);
                    const employeeList = data.map(emp => ({
                        value: emp.employeeUniqueId,
                        label: emp.fullName,
                        employeeId: emp.employeeId,
                        designation: emp.designation,
                    }));
                    setEmployees(employeeList);

                    // Initialize employeeData for table with API response values
                    const employeeData = data.map(emp => ({
                        id: emp.employeeUniqueId,
                        fullName: emp.fullName,
                        employeeId: emp.employeeId,
                        designation: emp.designation,
                        email: emp.email || '',
                        mobileNumber: emp.mobile || '',
                        // memberId: emp.uanMemberId || '',
                        fromDate: emp.fromDate || '',
                        postingLocation: emp.postingLocation || "",

                    }));

                    // Validate pre-populated data
                    const newErrors = {};
                    employeeData.forEach(emp => {
                        ['email', 'mobileNumber', 'memberId'].forEach(field => {
                            const error = validateInput(field, emp[field]);
                            if (error) {
                                newErrors[`${field}_${emp.id}`] = error;
                            }
                        });
                    });
                    setErrors(prev => ({ ...prev, ...newErrors }));
                    setEmployeeData(employeeData);
                } catch (error) {
                    console.error('Error fetching employees:', error);
                    setErrors(prev => ({ ...prev, employee: 'Failed to load employees' }));
                }
            };
            fetchEmployees();
        } else {
            setEmployees([]);
            setEmployeeData([]);
        }
    }, [project, state, clients, district]);

    // Handle input changes for dropdowns
    const handleInputChange = (selectedOption, field) => {
        const value = selectedOption ? selectedOption.value : null;
        setFormError('');
        switch (field) {
            case 'state':
                setState(value);
                setDistrict(null);
                setClients(null);
                setProject(null);
                setProjectResponse([]);
                setEmployees([]);
                setEmployeeData([]);
                break;
            case 'district':
                setDistrict(value);
                setEmployees([]);
                setEmployeeData([]);
                break;
            case 'clients':
                setClients(value);
                setProject(null);
                setProjectResponse([]);
                setEmployees([]);
                setEmployeeData([]);
                break;
            case 'project':
                setProject(value);
                setEmployees([]);
                setEmployeeData([]);
                break;
            default:
                break;
        }
        setErrors(prev => ({ ...prev, [field]: null }));
    };

    // Validation function
    const validateInput = (field, value) => {
        if (field === 'email' && value) {
            if (!validateEmail(value)) {
                return 'Please enter a valid email address';
            }
        }
        if (field === 'mobileNumber' && value) {
            if (!/^\d{10}$/.test(value)) {
                return 'Mobile Number must be exactly 10 digits';
            }
        }
        return null;
    };

    // Handle input changes for table fields
    const handleTableInputChange = (employeeId, field, value) => {
        let error = null;

        if (field === 'email') {
            if (value && !validateEmail(value)) {
                error = 'Please enter a valid email address';
            }
        }

        if (field === 'mobileNumber') {
            if (value && !/^\d{10}$/.test(value)) {
                error = 'Mobile Number must be exactly 10 digits';
            }
            value = value.replace(/\D/g, '').slice(0, 10); // Auto-clean non-digits
        }

        setErrors(prev => ({ ...prev, [`${field}_${employeeId}`]: error }));
        setEmployeeData(prev =>
            prev.map(emp =>
                emp.id === employeeId ? { ...emp, [field]: value } : emp
            )
        );
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        console.log("helloo");
        e.preventDefault();
        setFormError('');

        const updatedByUniqueId = localStorage.getItem("employeeUniqueIdLogin");
        const updatedBy = localStorage.getItem("role");
        if (isSubmitting) return; // Prevent multiple submissions
        setIsSubmitting(true);

        // Validate required fields
        if (!state) {
            setFormError('Please select State .');
            setIsSubmitting(false);
            return;
        }

        // Validate that at least one employee has data
        if (employeeData.length === 0) {
            setFormError('No employees available to submit.');
            setIsSubmitting(false);
            return;
        }

        // Validate that at least one employee has at least one field filled
        const hasValidData = employeeData.some(emp => emp.email || emp.mobileNumber);
        if (!hasValidData) {
            setFormError('Please provide at least one Email, Mobile Number for an employee.');
            setIsSubmitting(false);
            return;
        }
        console.log("helloo1");
        // Validate all inputs before submission
        let hasValidationErrors = false;
        const newErrors = {};
        employeeData.forEach(emp => {
            ['email', 'mobileNumber'].forEach(field => {
                const error = validateInput(field, emp[field]);
                if (error) {
                    newErrors[`${field}_${emp.id}`] = error;
                    hasValidationErrors = true;
                }
            });
        });
        console.log("helloo3");
        // if (hasValidationErrors) {
        //     setErrors(prev => ({ ...prev, ...newErrors }));
        //     setFormError('Please fix the validation errors before submitting.');
        //     setIsSubmitting(false);
        //     return;
        // }
        console.log("helloo4");
        try {
            // Prepare data for submission
            const submissionData = employeeData
                .filter(emp => emp.email || emp.mobileNumber)
                .map(emp => ({
                    employeeUniqueId: emp.id,
                    newEmail: emp.email || null,
                    newMobile: emp.mobileNumber ? Number(emp.mobileNumber) : null,
                    updatedBy,
                    updatedByUniqueId,
                }));

            console.log('Submitting →', submissionData);

            await emailMobileUpdate(submissionData);   // ← direct call
            alert('submitted successfully!');

            setState('');
            setClients('');
            setProject('');
            setDistrict('');
            setErrors({});
            setFormError('');
        } catch (error) {
            console.error('Error submitting email/mn data:', error);
            setFormError(
                error.response?.data?.error || 'An error occurred while submitting the data.'
            );
        } finally {
            setIsSubmitting(false);
        }
    };

    // Handle form clear
    const handleClear = () => {
        setState(null);
        setDistrict(null);
        setClients(null);
        setProject(null);
        setEmployees([]);
        setEmployeeData([]);
        setFormError('');
        setErrors({});
    };
    const gotoDashBoard = () => {
        navigate("/dashboard");
    };
    return (
        <div>
            <div className="email-mn-updation-box">
                <h2 className="email-mn-updation-heading">Email And Mobile Number Update</h2>

                <div className="email-mn-updation-maincontainer">
                    <div className="email-mn-updation-container-part">
                        <div
                            className={`email-mn-updation-floating-label-container ${isFocused.state || state ? 'float-label' : ''}`}
                        >
                            <Select
                                name="state"
                                options={stateOptions}
                                value={stateOptions.find(opt => opt.value === state) || null}
                                onChange={option => handleInputChange(option, 'state')}
                                onFocus={() => setIsFocused(prev => ({ ...prev, state: true }))}
                                onBlur={() => setIsFocused(prev => ({ ...prev, state: false }))}
                                placeholder=" "
                                isClearable
                                menuPortalTarget={document.body}
                                styles={selectStyles}
                            />
                            <label>
                                <span className="required">*</span>State
                            </label>
                            {errors.state && <div className="error-message">{errors.state}</div>}
                        </div>
                    </div>
                    <div className="email-mn-updation-container-part">
                        <div
                            className={`email-mn-updation-floating-label-container ${isFocused.district || district ? 'float-label' : ''}`}
                        >
                            <Select
                                name="district"
                                options={districtOptions}
                                value={districtOptions.find(opt => opt.value === district) || null}
                                onChange={option => handleInputChange(option, 'district')}
                                onFocus={() => setIsFocused(prev => ({ ...prev, district: true }))}
                                onBlur={() => setIsFocused(prev => ({ ...prev, district: false }))}
                                placeholder=" "
                                isClearable
                                menuPortalTarget={document.body}
                                styles={selectStyles}
                            />
                            <label>District</label>
                            {errors.district && <div className="error-message">{errors.district}</div>}
                        </div>
                    </div>
                </div>

                <div className="email-mn-updation-maincontainer">
                    <div className="email-mn-updation-container-part">
                        <div
                            className={`email-mn-updation-floating-label-container ${isFocused.clients || clients ? 'float-label' : ''}`}
                        >
                            <Select
                                name="clients"
                                options={clientResponse}
                                value={clientResponse.find(opt => opt.value === clients) || null}
                                onChange={option => handleInputChange(option, 'clients')}
                                onFocus={() => setIsFocused(prev => ({ ...prev, clients: true }))}
                                onBlur={() => setIsFocused(prev => ({ ...prev, clients: false }))}
                                placeholder=" "
                                isClearable
                                menuPortalTarget={document.body}
                                styles={selectStyles}
                            />
                            <label>Client</label>
                            {errors.clients && <div className="error-message">{errors.clients}</div>}
                        </div>
                    </div>

                    <div className="email-mn-updation-container-part">
                        <div
                            className={`email-mn-updation-floating-label-container ${isFocused.project || project ? 'float-label' : ''}`}
                        >
                            <Select
                                name="project"
                                options={projectResponse}
                                value={projectResponse.find(opt => opt.value === project) || null}
                                onChange={option => handleInputChange(option, 'project')}
                                onFocus={() => setIsFocused(prev => ({ ...prev, project: true }))}
                                onBlur={() => setIsFocused(prev => ({ ...prev, project: false }))}
                                placeholder=" "
                                isClearable
                                menuPortalTarget={document.body}
                                styles={selectStyles}
                            />
                            <label>Project</label>
                            {errors.project && <div className="error-message">{errors.project}</div>}
                        </div>
                    </div>
                </div>

                {formError && (
                    <div className="error-message form-error">{formError}</div>
                )}
            </div>

            <div className="email-mn-table-container">
                <table className="email-mn-table">
                    <thead>
                        <tr>
                            <th>S.no</th>
                            <th>Employee ID</th>
                            <th>Employee Name</th>
                            <th>Designation</th>
                            {/* <th>Joining Date</th> */}
                            {/* <th>Posting location</th> */}
                            <th>Email</th>
                            {/* <th>Member ID</th> */}
                            <th>Mobile Number</th>
                        </tr>
                    </thead>
                    <tbody>
                        {employeeData.length > 0 ? (
                            employeeData.map((emp, index) => (
                                <tr key={emp.id}>
                                    <td>{index + 1}</td>
                                    <td>{emp.employeeId}</td>
                                    <td>{capitalizeFirstLetter(emp.fullName)}</td>
                                    <td>{emp.designation}</td>
                                    {/* <td>{format(emp.fromDate, 'dd-MM-yyyy')}</td> */}
                                    {/* <td>{emp.postingLocation}</td> */}
                                    <td>
                                        <input
                                            type="email"
                                            value={emp.email}
                                            onChange={e =>
                                                handleTableInputChange(emp.id, 'email', e.target.value)
                                            }
                                            //   onPaste={e => {
                                            //     const pastedValue = e.clipboardData.getData('text');
                                            //     if (!/^\d*$/.test(pastedValue)) {
                                            //       e.preventDefault();
                                            //     }
                                            //   }}
                                            placeholder="Email"
                                        // maxLength={12}
                                        //   disabled={!!emp.email}
                                        //   className={emp.email ? 'disabled-input' : ''}
                                        //  className={errors[`email_${emp.id}`] ? 'error' : ''}
                                        />
                                        {errors[`email_${emp.id}`] && (
                                            <div className="error-message-uan">{errors[`email_${emp.id}`]}</div>
                                        )}
                                    </td>

                                    <td>
                                        <input
                                            type="text"
                                            value={emp.mobileNumber}
                                            onChange={e =>
                                                handleTableInputChange(emp.id, 'mobileNumber', e.target.value)
                                            }
                                            //   onPaste={e => {
                                            //     const pastedValue = e.clipboardData.getData('text');
                                            //     if (!/^\d*$/.test(pastedValue)) {
                                            //       e.preventDefault();
                                            //     }
                                            //   }}
                                            placeholder="Mobile Number"
                                            maxLength={10}
                                        //   disabled={!!emp.mobileNumber}
                                        //   className={emp.mobileNumber ? 'disabled-input' : ''}
                                        />
                                        {errors[`mobileNumber_${emp.id}`] && (
                                            <div className="error-message-mn">{errors[`mobileNumber_${emp.id}`]}</div>
                                        )}
                                    </td>

                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan="9" className='employee-notfound'>No employees available</td>
                            </tr>
                        )}
                    </tbody>
                </table>
                <div className="email-mn-updation-maincontainer">
                    <button
                        type="button"
                        className="email-mn-submit-btn"
                        onClick={handleSubmit}
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? 'Submitting...' : 'Submit'}
                    </button>


                    <button
                        type="button"
                        className="email-mn-clear-btn"
                        onClick={handleClear}
                        disabled={isSubmitting}
                    >
                        Clear
                    </button>

                    <button type='button' onClick={gotoDashBoard} className="email-mn-close-btn">Close</button>
                </div>
            </div>
        </div>
    );
};

export default EmployeeEmailAndMobileNumberUpdate;